'use strict';

/**
 * Get top and left positioning for centering social pop-up window
 * @param {number} windowHeight
 * @param {number} windowWidth
 * @returns {{top: number, left: number}}
 */
function getSocialWindowDimensions(windowHeight, windowWidth) {
    const screenHeight = screen.height;
    const screenWidth = screen.width;
    const left = Math.round(screenWidth / 2 - windowWidth / 2);
    let top = 0;

    if (screenHeight > windowHeight) {
        top = Math.round(screenHeight / 2 - windowHeight / 2);
    }

    return {
        top: top,
        left: left,
    };
}

module.exports = getSocialWindowDimensions;



// WEBPACK FOOTER //
// ./assets/js/social/helpers/getSocialWindowPosition.es.js